<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="classSignups"
            hide-default-footer
            :loading="loading"
        >
            <template v-slot:item.name="{ item }">
                {{
                    item.familyUserId ? item.familyUserFullName : item.fullName
                }}
            </template>
            <template
                v-slot:item.actions="{ item }"
                v-if="bookingType === 'group'"
            >
                <v-btn
                    small
                    depressed
                    color="grey lighten-3"
                    class="ml-2"
                    @click="() => openAssignSpotDialog(item)"
                >
                    <v-icon size="16" class="mr-1">mdi-pencil-outline</v-icon
                    >{{ $t('message.changeAttendee') }}
                </v-btn>
            </template>
        </v-data-table>
        <AssignSpotDialog
            :isOpen="assignSpotDialog"
            :accounts="subAccounts || []"
            :selectedSpot="selectedSpot"
            @close="assignSpotDialog = false"
            @refresh="setClassSignups"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AUTHENTICATION_MODULE_NAME } from '@/store/moduleNames'
import {
    getClassSignups,
    getGroupBookedSignup,
} from '@/util/classes/getClassSignups'
import AssignSpotDialog from '../../components/myclasses/AssignSpotDialog.vue'
export default {
    props: {
        classId: String,
        userIds: Array,
        subAccounts: Array,
        bookingType: String,
        spotNumbers: Array,
        hideSpots: Boolean,
    },
    components: {
        AssignSpotDialog,
    },
    data() {
        return {
            headers: [
                { text: 'Spot Number', value: 'spotNumber' },
                { text: 'Name', value: 'name' },
                { text: '', value: 'actions' },
            ],
            classSignups: [],
            assignSpotDialog: false,
            selectedSpot: {},
        }
    },
    computed: {
        ...mapGetters({
            user: `${AUTHENTICATION_MODULE_NAME}/getUser`,
        }),
    },
    methods: {
        async setClassSignups() {
            this.loading = true
            const classSignups = await Promise.all(
                this.userIds.map(async (userId) => {
                    return getClassSignups(this.classId, userId)
                })
            )
            const groupBookedSignup = await getGroupBookedSignup(
                this.classId,
                this.user.id
            )
            const uniqueMap = new Map()
            const flatClassSignups = classSignups.flat()
            flatClassSignups.forEach((x) => {
                uniqueMap.set(x.id, x)
            })

            groupBookedSignup.forEach((x) => {
                uniqueMap.set(x.id, x)
            })
            this.classSignups = Array.from(uniqueMap.values())
            this.classSignups.sort((a, b) => a.spotNumber - b.spotNumber)
            if (!this.hideSpots)
                this.classSignups = this.classSignups.filter((x) =>
                    this.spotNumbers.includes(x.spotNumber)
                )
            this.loading = false
        },
        openAssignSpotDialog(item) {
            this.selectedSpot = item
            this.assignSpotDialog = true
        },
    },
    created() {
        this.setClassSignups()
    },
}
</script>
